import { categoryGroups, type FilterCategory } from './FilterByDropdown';
import type { FilterChipGroup } from './FilterChipsList';

export function toChipGroups(categories: FilterCategory[]): FilterChipGroup[] {
  return categories.map((category) => ({
    label: category.label,
    chips: categoryGroups(category).flatMap(({key, options, selected, onChange}) =>
      selected.map((value) => ({
        id: `${key}:${value}`,
        label: options.find((option) => option.value === value)?.label ?? value,
        onDismiss: () => onChange(selected.filter((v) => v !== value)),
      })),
    ),
  }));
}
